module.exports = __webpack_public_path__ + "static/img/p1.7908300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word-game/p1.jpg
// module id = hhdv
// module chunks = 0